import axios from 'axios'
import { UrlBase } from './config'

const cancelToken = axios.CancelToken
let sourceCampaigns = cancelToken.source()
let sourceCampaignUserList = cancelToken.source()

const campaigns = {}

campaigns.archiveCampaign = async (token, companyId, appId, campaignId, archiveCampaign) => {
  try {
    const request = {
      method: 'PUT',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: UrlBase + 'companies/' + companyId + '/apps/' + appId + '/campaigns/' + campaignId + '/archive',
      data: {
        archiveCampaign: archiveCampaign.toString()
      }
    }

    const response = await axios(request)
    return response.data
  } catch (error) {
    const message = error.response
    if (!message) throw new Error(error.message)
    else throw new Error(message.data.error)
  }
}

campaigns.createCampaign = (token, companyId, appId, { name, type, date, listId, email, sms, push, whatsapp }) => {
  return new Promise((resolve, reject) => {
    const options = {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: UrlBase + 'companies/' + companyId + '/apps/' + appId + '/campaigns',
      data: { name, type, date, listId, email, sms, push, whatsapp, status: 'draft' }
    }

    axios(options).then(response => {
      resolve(response.data)
    }).catch(error => {
      const message = error.response
      if (!message) return reject(new Error(error.message))
      else return reject(new Error(message.data.error))
    })
  })
}

campaigns.createCampaignUserList = (token, companyId, appId, campaignId, createFromUser) => {
  return new Promise((resolve, reject) => {
    const options = {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: UrlBase + 'companies/' + companyId + '/apps/' + appId + '/campaigns/' + campaignId + '/users/create/list',
      data: { createFromUser }
    }

    axios(options).then(response => {
      resolve(response.data)
    }).catch(error => {
      const message = error.response
      if (!message) return reject(new Error(error.message))
      else return reject(new Error(message.data.error))
    })
  })
}

campaigns.deleteCampaignFile = async (token, companyId, appId, campaignId, fileName) => {
  try {
    const request = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${token}`
      },
      data: { fileName },
      url: `${UrlBase}companies/${companyId}/apps/${appId}/campaigns/${campaignId}/remove/attachment`
    }
    await axios(request)
  } catch (e) {
    const message = e.response
    if (!message) {
      throw new Error(e.message)
    } else {
      throw new Error(message)
    }
  }
}

campaigns.downloadCampaignFile = async (token, companyId, appId, campaignId, fileName) => {
  try {
    const request = {
      method: 'GET',
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${token}`
      },
      params: { fileName },
      url: `${UrlBase}companies/${companyId}/apps/${appId}/campaigns/${campaignId}/download/attachment`
    }
    const response = await axios(request)
    const link = document.createElement('a')
    link.href = window.URL.createObjectURL(new Blob([response.data]))
    link.setAttribute('download', `${fileName}`)
    link.setAttribute('target', '_blank')
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  } catch (e) {
    const message = e.response
    if (!message) {
      throw new Error(e.message)
    } else {
      throw new Error(message)
    }
  }
}

campaigns.exportCampaign = (token, companyId, appId, campaignId, { filename }) => {
  return new Promise((resolve, reject) => {
    const request = {
      method: 'GET',
      responseType: 'blob',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: UrlBase + 'companies/' + companyId + '/apps/' + appId + '/campaigns/' + campaignId + '/export/bin'
    }
    axios(request)
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `${filename}.xlsx`)
        document.body.appendChild(link)
        link.click()
        resolve(true)
      })
      .catch(error => {
        const message = error.response
        if (!message) return reject(new Error(error.message))
        else return reject(new Error(message.data.error))
      })
  })
}

campaigns.getCampaign = (token, companyId, appId, campaignId) => {
  return new Promise((resolve, reject) => {
    const options = {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: UrlBase + 'companies/' + companyId + '/apps/' + appId + '/campaigns/' + campaignId
    }
    axios(options)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        const message = error.response
        if (!message) return reject(new Error(error.message))
        else return reject(new Error(message.data.error))
      })
  })
}

campaigns.getCampaignUsersList = (token, companyId, appId, campaignId, pagination, search, advancedSearch) => {
  sourceCampaignUserList.cancel('Operation canceled')
  sourceCampaignUserList = cancelToken.source()
  return new Promise((resolve, reject) => {
    const options = {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token
      },
      params: {
        page: pagination.page,
        sortBy: pagination.sortBy,
        descending: pagination.descending,
        limit: pagination.itemsPerPage,
        search: search,
        status: advancedSearch.status
      },
      url: UrlBase + 'companies/' + companyId + '/apps/' + appId + '/campaigns/' + campaignId + '/users',
      cancelToken: sourceCampaignUserList.token
    }
    axios(options)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        if (error.message === 'Operation canceled') return resolve(true)
        const message = error.response
        if (!message) return reject(new Error(error.message))
        else return reject(new Error(message.data.error))
      })
  })
}

campaigns.getCampaigns = (token, companyId, appId, pagination, name, archivedCampaign) => {
  sourceCampaigns.cancel('Operation canceled')
  sourceCampaigns = cancelToken.source()
  return new Promise((resolve, reject) => {
    const options = {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token
      },
      params: {
        page: pagination.page,
        sortBy: pagination.sortBy,
        descending: pagination.descending,
        limit: pagination.itemsPerPage,
        name: name,
        archivedCampaign: archivedCampaign
      },
      url: UrlBase + 'companies/' + companyId + '/apps/' + appId + '/campaigns',
      cancelToken: sourceCampaigns.token
    }
    axios(options).then(response => {
      resolve(response.data)
    }).catch(error => {
      console.log(error)
    })
  })
}

campaigns.getTheErrorsGeneratedByTheUpload = (token, companyId, appId, campaignId, pagination) => {
  return new Promise((resolve, reject) => {
    const options = {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token
      },
      params: {
        page: pagination.page,
        sortBy: pagination.sortBy,
        descending: pagination.descending,
        limit: pagination.itemsPerPage
      },
      url: UrlBase + 'companies/' + companyId + '/apps/' + appId + '/campaigns/' + campaignId + '/massive/errors'
    }
    axios(options)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        const message = error.response
        if (!message) return reject(new Error(error.message))
        else return reject(new Error(message.data.error))
      })
  })
}

campaigns.sendCampaign = (token, companyId, appId, campaignId, { schedule, scheduleDate }) => {
  return new Promise((resolve, reject) => {
    const options = {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: UrlBase + 'companies/' + companyId + '/apps/' + appId + '/campaigns/' + campaignId + '/users/send',
      data: { schedule, scheduleDate }
    }
    axios(options)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        const message = error.response
        if (!message) return reject(new Error(error.message))
        else return reject(new Error(message.data.error))
      })
  })
}

campaigns.uploadUsersForTheCampaignDirectly = (token, companyId, appId, campaignId, file) => {
  return new Promise((resolve, reject) => {
    const fd = new FormData()
    /* eslint-enable */
    fd.append('upload-files', file)

    const options = {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: UrlBase + 'companies/' + companyId + '/apps/' + appId + '/campaigns/' + campaignId + '/massive/upload',
      data: fd
    }

    axios(options).then(response => {
      resolve(response.data)
    }).catch(error => {
      const message = error.response
      if (!message) return reject(new Error(error.message))
      else return reject(new Error(message.data.error))
    })
  })
}

campaigns.saveTemplate = async (token, companyId, appId, data) => {
  const { name, template } = data
  const options = {
    method: 'POST',
    headers: {
      Authorization: 'Bearer ' + token
    },
    url: UrlBase + 'companies/' + companyId + '/apps/' + appId + '/email/' + 'templates',
    data: { name, template }
  }
  try {
    const response = await axios(options)
    return response.data
  } catch (error) {
    const message = error.response
    if (!message) throw new Error(error.message)
    else throw new Error(message.data.error)
  }
}

campaigns.getTemplateById = async (token, companyId, appId, templateId) => {
  const options = {
    method: 'GET',
    headers: {
      Authorization: 'Bearer ' + token
    },
    url: UrlBase + 'companies/' + companyId + '/apps/' + appId + '/email/' + 'templates/' + templateId
  }

  try {
    const response = await axios(options)
    return response.data
  } catch (error) {
    const message = error.response
    if (!message) throw new Error(error.message)
    else throw new Error(message.data.error)
  }
}

campaigns.getTemplates = async (token, companyId, appId) => {
  const options = {
    method: 'GET',
    headers: {
      Authorization: 'Bearer ' + token
    },
    url: UrlBase + 'companies/' + companyId + '/apps/' + appId + '/email/' + 'templates'
  }

  try {
    const response = await axios(options)
    return response.data
  } catch (error) {
    const message = error.response
    if (!message) throw new Error(error.message)
    else throw new Error(message.data.error)
  }
}

campaigns.getTemplatesByName = async (token, companyId, appId, templateName) => {
  const options = {
    method: 'GET',
    headers: {
      Authorization: 'Bearer ' + token
    },
    url: UrlBase + 'companies/' + companyId + '/apps/' + appId + '/email/' + '/templates?name=' + templateName
  }

  try {
    const responde = await axios(options)
    return responde.data
  } catch (error) {
    const message = error.response
    if (!message) throw new Error(error.message)
    else throw new Error(message.data.error)
  }
}

campaigns.uploadFileToCampaign = async (token, companyId, appId, campaignId, file) => {
  try {
    const fd = new FormData()
    fd.append('attachments', file)
    const request = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${token}`
      },
      data: fd,
      url: `${UrlBase}companies/${companyId}/apps/${appId}/campaigns/${campaignId}/upload/attachment`
    }
    await axios(request)
  } catch (e) {
    const message = e.response
    if (!message) {
      throw new Error(e.message)
    } else {
      throw new Error(message)
    }
  }
}

campaigns.updateTemplate = async (token, companyId, appId, data) => {
  const { template, templateId } = data
  const options = {
    method: 'PUT',
    headers: {
      Authorization: 'Bearer ' + token
    },
    url: UrlBase + 'companies/' + companyId + '/apps/' + appId + '/email/' + 'templates/' + templateId,
    data: { template }
  }
  try {
    const response = await axios(options)
    return response.data
  } catch (error) {
    const message = error.response
    if (!message) throw new Error(error.message)
    else throw new Error(message.data.error)
  }
}

export default campaigns
